import './ReportComponentTypeFilter.scss';
import { caseInsensitiveContainsFilterOption } from '@lib/filter';
import React from 'react';
import { REPORT_COMPONENT_TYPES } from '@sonar-software/sonar-ts-constants';
import { Select } from 'antd';
import { SfReportComponentType } from '@sonar-software/sonar-ts-types';
const options = [
    {
        label: REPORT_COMPONENT_TYPES.AGGREGATE_COLUMN,
        value: SfReportComponentType.AggregateColumn
    },
    {
        label: REPORT_COMPONENT_TYPES.COLUMN,
        value: SfReportComponentType.Column
    },
    {
        label: REPORT_COMPONENT_TYPES.CROSS_FILTER,
        value: SfReportComponentType.CrossFilter
    },
    {
        label: REPORT_COMPONENT_TYPES.CROSS_FILTER_CRITERIA,
        value: SfReportComponentType.CrossFilterCriterion
    },
    {
        label: REPORT_COMPONENT_TYPES.CUSTOM_DETAIL_FORMULA,
        value: SfReportComponentType.CustomDetailFormula
    },
    {
        label: REPORT_COMPONENT_TYPES.CUSTOM_SUMMARY_FORMULA,
        value: SfReportComponentType.CustomSummaryFormula
    },
    {
        label: REPORT_COMPONENT_TYPES.FILTER,
        value: SfReportComponentType.Filter
    },
    {
        label: REPORT_COMPONENT_TYPES.GROUPING,
        value: SfReportComponentType.Grouping
    }
];
export const ReportComponentTypeFilter = ({ onChange, selected = [] }) => React.createElement(Select, { allowClear: true, className: 'report-component-type-filter', filterOption: caseInsensitiveContainsFilterOption, mode: 'multiple', onChange: (componentTypes) => onChange({ componentTypes }), options: options, placeholder: 'Filter by Component Type', value: selected });
